<template>
  <div style="height: 100%">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link :to="{ path: '/' }">
            <span style="color: #4a90e2">
              <i class="el-icon-location"></i>
              {{ $t('report.首页') }}
            </span>
          </router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ $t('report.设备报表') }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div id="form">
      <el-card class="box-card" shadow="never">
          <div style="margin-bottom: 10px; color: #666">
            {{ $t('report.筛选条件') }}
          </div>
          <div>
            <el-select
              v-model="remoteVal"
              @change="remoteValChange"
              value-key="id"
              size="mini"
              :no-data-text="$t('home.noData')"
              :placeholder="$t('report.请选择设备类型')"
            >
              <el-option v-for="o in remoteGroupArr" :key="o.id" :label="o.typeName" :value="o"></el-option>
            </el-select>
            <el-select
              v-model="remoteVal2"
              multiple
              style="margin-left: 10px"
              :collapse-tags="true"
              @change="remoteValChange2"
              size="mini"
              :no-data-text="$t('home.noData')"
              :placeholder="$t('report.请选择设备')"
            >
              <el-option v-for="o in remoteGroupArr2" :key="o.equipid" :label="o.equipname" :value="o.equipid"></el-option>
            </el-select>
            <el-select
              v-model="remoteVal3"
              @change="remoteValChange3"
              value-key="id"
              style="margin-left: 10px"
              size="mini"
              :no-data-text="$t('home.noData')"
              :placeholder="$t('report.请设备参数')"
            >
              <el-option v-for="o in remoteGroupArr3" :key="o.id" :label="o.name" :value="o"></el-option>
            </el-select>
            <!-- <el-date-picker @change="change"
                          v-model="daterange"
                          style="margin-left:10px;"
                          size="mini"
                          value-format="yyyy-MM-dd"
                          type="daterange"
                          :unlink-panels="true"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker> -->
            <el-date-picker
              v-model="daterange"
              type="date"
              :placeholder="$t('report.开始日期')"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsStart"
            ></el-date-picker>
            {{ $t('report.至') }}
            <el-date-picker
              v-model="daterangeend"
              type="date"
              :placeholder="$t('report.结束日期')"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsEnd"
            ></el-date-picker>
          </div>
          <div style="margin-top: 10px">
            <el-button type="primary" @click="openReport">{{ $t('report.生成报表图') }}</el-button>
          </div>
          <div class="block" style="margin-top: 12px; margin-bottom: 12px">
            <div id="main" style="width: 100%; height: calc(100vh - 340px)"></div>
          </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { mapState } from 'vuex'
import { reportGroup, report } from '../service/getData'
const echarts = require('echarts') // 引入 ECharts 主模块
let myChart
import { equipinfo } from '../service/getData'
import { getToken } from '../utils/auth'
import moment from 'moment'
export default {
  name: 'app',
  data() {
    return {
      json_data: null,
      json_fields: null,
      pagesize: 40,
      pnum: 6000,
      currentPage: 1,
      total: 0,
      List: [
        { id: '1', text: '00', value: `id=1,${this.$t('report.选择了')}00` },
        { id: '2', text: '01', value: `id=2,${this.$t('report.选择了')}01` },
        { id: '3', text: '02', value: `id=3,${this.$t('report.选择了')}02` },
        { id: '4', text: '03', value: `id=4,${this.$t('report.选择了')}03` },
        { id: '5', text: '04', value: `id=5,${this.$t('report.选择了')}04` },
        { id: '6', text: '05', value: `id=6,${this.$t('report.选择了')}05` },
        { id: '7', text: '06', value: `id=7,${this.$t('report.选择了')}06` },
        { id: '8', text: '07', value: `id=8,${this.$t('report.选择了')}07` },
        { id: '9', text: '08', value: `id=9,${this.$t('report.选择了')}08` },
        { id: '10', text: '09', value: `id=10,${this.$t('report.选择了')}09` },
        { id: '11', text: '10', value: `id=11,${this.$t('report.选择了')}10` },
        { id: '12', text: '11', value: `id=12,${this.$t('report.选择了')}11` },
        { id: '13', text: '12', value: `id=13,${this.$t('report.选择了')}12` },
        { id: '14', text: '13', value: `id=14,${this.$t('report.选择了')}13` },
        { id: '15', text: '14', value: `id=15,${this.$t('report.选择了')}14` },
        { id: '16', text: '15', value: `id=16,${this.$t('report.选择了')}15` },
        { id: '17', text: '16', value: `id=17,${this.$t('report.选择了')}16` },
        { id: '18', text: '17', value: `id=18,${this.$t('report.选择了')}17` },
        { id: '19', text: '18', value: `id=19,${this.$t('report.选择了')}18` },
        { id: '20', text: '19', value: `id=20,${this.$t('report.选择了')}19` },
        { id: '21', text: '20', value: `id=21,${this.$t('report.选择了')}20` },
        { id: '22', text: '21', value: `id=22,${this.$t('report.选择了')}21` },
        { id: '23', text: '22', value: `id=23,${this.$t('report.选择了')}22` },
        { id: '24', text: '23', value: `id=24,${this.$t('report.选择了')}23` }
      ],

      daterange: '',
      daterangeend: '',
      // 开始时间
      dbt:
        null ||
        moment()
          .subtract(1, 'year')
          .format('YYYY-MM-DD'),
      // 结束时间
      edt: null || moment().format('YYYY-MM-DD'),
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.daterangeend
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime() || time.getTime() > Date.now()
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.daterange
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000 || time.getTime() > Date.now()
          }
        }
      },
      remoteGroupArr: null,
      remoteGroupArr2: null,
      remoteGroupArr3: null,
      remoteVal: null,
      remoteVal2: [],
      remoteVal3: null
    }
  },
  computed: {
    ...mapState(['deviceItems'])
  },
  methods: {
    remoteValChange(v) {
      this.remoteGroupArr2 = v.equips
      this.remoteGroupArr3 = v.param

      this.remoteVal2 = []
      this.remoteVal3 = null
    },
    remoteValChange2() {},
    remoteValChange3() {},
    async openReport() {
      if (!(this.remoteVal2.length && this.remoteVal3)) {
        Toast(this.$t('detail.请完善查询条件'))
        return null
      }
      let timeData = await report(this.daterange, this.daterangeend, this.remoteVal2.toString(), this.remoteVal3.id)
      // if (timeData.data.ResultType == 0) {
      //   this.$message({
      //     message: data.Message,
      //     type: 'success',
      //   })
      // } else {
      //   console.log(timeData.data)
      //   this.$message({
      //     message: this.$t('detail.请完善查询条件'),
      //     type: 'error',
      //   })
      // }
      let legendData = []
      this.remoteVal2.map(n => {
        let obj = this.remoteGroupArr2.find(m => n === m.equipid)
        legendData.push(obj.equipname)
      })
      myChart.showLoading()
      setTimeout(() => {
        myChart.hideLoading()
      }, 1000)
      // 绘制图表
      let data = timeData.data.AppendData.map(item => {
        item['smooth'] = true
        item['seriesLayoutBy'] = 'row'
        item['symbol'] = 'none'
        return item
      })
      myChart.setOption({
        title: {
          text: `${this.remoteVal3.name}${this.$t('detail.报表')}`
        },
        color: ['#FF4081', '#448AFF', '#00BCD4', '#009688', '#7C4DFF', '#F44336', '#FFC107', '#607D8B', '#4CAF50'],
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            params = params[0]
            return `${params.value[0]} ${params.value[1]}`
          },
          axisPointer: {
            animation: false //不开启动画
          }
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: true
          }
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show: true
          }
        },
        legend: {
          data: legendData
        },
        series: data //timeData.data.AppendData
      })
    },
    value2OnChange() {},
    valueallOnChange(valueall) {
      this.value = null
      this.value2 = []
      this.value3 = null

      if (valueall == 0) {
        let slttype = this.reportList[0].items
        this.value1List = slttype
      } else {
        let slttypee = this.reportList[1].items
        this.value1List = slttypee
      }
    },
    async valueOnChange(value) {
      this.value2List = null
      this.value3List = null
      this.value2 = []
      this.value3 = null
      //this.value4 = null
      this.value5 = null
      this.value4List = null
      this.alltypename = null
      this.typename = null
      this.typename1 = null

      let obj = this.deviceItems.find((item, index) => {
        return value === index
      })
      this.value2List = obj.items
      if (this.value2List.length) {
        let tpList = await equipinfo(this.value2List[0].equipid)
        this.value3List = tpList.data.tp
      }
    }
  },
  async mounted() {
    // 测试mock数据，对应接口：报表获取分组及明细
    let res = await reportGroup()
    this.remoteGroupArr = res.data.AppendData || []
    this.reportList = res.data
    if (!getToken()) {
      this.$router.push('/login')
      return
    }

    myChart = echarts.init(document.getElementById('main'))
  }
}
</script>
<style lang="scss" scoped>
#map {
  background: white;
  height: 90%;
}
.daochu {
  display: flex;
}
.word {
  width: 140px;
}
.table {
  border-left: 1px solid #f1f1f1;
  border-top: 1px solid #f1f1f1;
  border-collapse: collapse;

  td {
    border-right: 1px solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
    padding: 8px 12px;
  }
}
.flexbox {
  display: flex;
}
.flexbox1 {
  display: flex;
  width: 450px;
  height: 50px;
}

.first {
  margin-right: 0px;
  width: 300px;
}
.second {
  margin-right: 0px;
  width: 300px;
}
.third {
  margin-right: 0px;
  width: 300px;
}
.fourth {
  margin-right: 0px;
  width: 300px;
}
.fifth {
  margin-right: 0px;
  width: 300px;
}
.sixth {
  margin-right: 0px;
  width: 300px;
}
.seventh {
  margin-right: 0px;
  width: 300px;
}
.eighth {
  margin-right: 0px;
  width: 300px;
}
.bb {
  margin-left: 30px;
  margin-top: 2px;
}
.cc {
  margin-left: 80px;
}
/*.aa {
  margin-left: 60px;
}


.ee {
  margin-left: 61px;
}*/
.btn-save {
  display: block;
  margin: 0 auto;
  width: 100px;
  height: 30px;
}


</style>
